import { Button, cn } from "@tellescope/ui";
import { ReactNode } from "react";
import { useShallowNavbarStore } from "../store";
import { PanelLeft, X } from "lucide-react";
import { usePageLabel } from "../hooks";
import { useTranslation } from "react-i18next";
import { PAGE_HEADER_SIZE_STRING } from "../constants/header-sizing";

export interface PageHeaderProps {
  children?: ReactNode;
  onClose?: () => void;
  className?: string;
}

export const PageHeader = ({ children, onClose, className }: PageHeaderProps) => {
  const { t } = useTranslation();
  const { isCollapsed, toggleCollapsed } = useShallowNavbarStore("isCollapsed", "toggleCollapsed");
  const pageTitle = usePageLabel(t("Tellescope"));

  return (
    <div
      className={cn(
        `flex items-center px-2 border-b min-h-[${PAGE_HEADER_SIZE_STRING}] h-[${PAGE_HEADER_SIZE_STRING}] justify-between w-full flex-shrink-0`,
        className
      )}
    >
      <div className="flex items-center gap-2 w-full">
        <Button
          variant="ghost"
          size="icon"
          className="w-9 h-9 rounded-md"
          onClick={toggleCollapsed}
          title={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          <PanelLeft className="h-5 w-5" />
        </Button>
        {typeof children === "string" || typeof children === "undefined" ? (
          <h1 className="text-xl font-bold truncate">{children ?? pageTitle}</h1>
        ) : (
          children
        )}
      </div>
      {!!onClose && (
        <Button variant="ghost" size="sm-icon" onClick={onClose}>
          <X />
        </Button>
      )}
    </div>
  );
};
